exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bankapos-report-table[data-v-2b6a5e7c]{width:100%;margin-top:4px}.bankapos-report-table>*[data-v-2b6a5e7c]{width:100%}", ""]);

// exports
